module.exports = __webpack_public_path__ + "static/media/fruit-bars.204589a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/whereToBuy/fruit-bars.png
// module id = 214
// module chunks = 0